import { useMemo } from 'react';

import { CarAttentionItemDto, PermissionDto } from '@/api/generated';
import { useUserContext } from '@/contexts/userContext/User.context.ts';
import { useHasAnyPermission } from '@/utils/usePermissions.util.ts';
import { isUrgent } from '@/views/cars/maintenance/util/carAttention.util.ts';
import { useGetCarsAttention } from '@/views/cars/maintenance/util/useGetCarsAttention.util.ts';

type Return = {
  items: CarAttentionItemDto[];
  toDoCount: number;
  urgentItems: CarAttentionItemDto[];
};

export const useCarsToDo = (): Return => {
  const { dataReady, userId } = useUserContext();
  const canSeeCars = useHasAnyPermission(PermissionDto.MenuCars);
  const seesEveryCar = useHasAnyPermission(PermissionDto.ViewAllCarTodos);
  const { attentionItems } = useGetCarsAttention({ enabled: dataReady && canSeeCars });

  const items = useMemo(
    () => attentionItems.filter(item => seesEveryCar || item.responsibleUserId === userId),
    [attentionItems, seesEveryCar, userId],
  );
  const urgentItems = useMemo(() => items.filter(isUrgent), [items]);

  return {
    items,
    toDoCount: items.length,
    urgentItems,
  };
};
